import React, { Component } from 'react';
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';

class RMAPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contents: ''
    }
  }

  onContentsChange = (e) => {
    this.setState({contents: e.target.value})
  }

  onSubmitClick = () => {
    this.props.onRMASubmit(this.state.contents);
    this.setState({contents: ''});
  }

  render() {
    return (
      <MDBContainer>
        <MDBModal isOpen={this.props.RMAPopup} toggle={this.props.toggle}>
          <MDBModalHeader toggle={this.props.toggle}>Log Contents</MDBModalHeader>
          <MDBModalBody>
          <label htmlFor="exampleFormControlTextarea1">Details</label><br/>
          <textarea
            className="form-control"
            onChange={(e) => {this.onContentsChange(e)}}
            id="exampleFormControlTextarea1"
            rows="5"
            value={this.state.contents}
          />
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn color="primary" onClick={this.props.toggle}>Close</MDBBtn>
            <MDBBtn color="primary" onClick={() => {this.onSubmitClick()} }>Save changes</MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
      );
    }
}

export default RMAPopup;
